import React, { useState, useEffect } from 'react';

const Clock = () => {
  const [time, setTime] = useState('00:00:00');

  useEffect(() => {
    // Function to format the current time as hh:mm:ss
    const formatTime = (date) => {
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // Set to true for 12-hour format
      });
    };

    // Update the time every second
    const intervalId = setInterval(() => {
      const now = new Date();
      setTime(formatTime(now));
    }, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        aligContent: 'center',
        paddingTop: '5px',
        color: '#e162a7',
        marginLeft: '5px',
      }}
    >
      {time}
    </div>
  );
};

export default Clock;
